import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Menu, Transition } from '@headlessui/react';
import { OwnProfileResponse } from '../store/backendApi';

function classNames(...classes: string[]) {
  return classes.filter(Boolean).join(' ');
}

export interface PageProps {
  user?: OwnProfileResponse | null;
}

export interface ShellProps {
  children: React.ReactElement;
  profile?: OwnProfileResponse | null;
}

const Shell = React.memo((props: ShellProps) => {
  console.log('render shell');
  return (
    <>
      <div>
        <div className="flex flex-col flex-1">
          <div className="sticky top-0 z-20 flex-shrink-0 flex h-16 shadow bg-[#eee]">
            <div className="flex-1 px-4 flex ml-4 md:ml-6 items-center justify-between">
              <div></div>
              <div className="absolute left-1/2 transform -translate-x-1/2">
                <a href="/">
                  <img src="/logo_side_full_big.png" alt="TripVibes" className="h-10" />
                </a>
              </div>
              <div className="ml-4 flex items-center md:ml-6">
                <Menu as="div" className="ml-3 relative">
                  <div>
                    <Menu.Button
                      className="max-w-xs bg-white flex items-center text-sm rounded-full
                    focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
                    >
                      <span className="sr-only">Open user menu</span>
                      <div>
                        {props.profile && (
                          <img
                            className="max-w-full w-10 h-10 rounded-full object-cover"
                            alt={props.profile.username}
                            title={props.profile.username}
                            src={`https://media.${process.env.REACT_APP_HOST}/users/${
                              props.profile.userId
                            }-thumbnail.jpg?v=${Date.now()}`}
                            loading="eager"
                            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
                            // @ts-ignore
                            fetchpriority="high"
                            onError={(e) => (e.currentTarget.src = '/default-profile-picture.jpg')}
                          />
                        )}
                      </div>
                    </Menu.Button>
                  </div>
                  <Transition
                    as={Fragment}
                    enter="transition ease-out duration-100"
                    enterFrom="transform opacity-0 scale-95"
                    enterTo="transform opacity-100 scale-100"
                    leave="transition ease-in duration-75"
                    leaveFrom="transform opacity-100 scale-100"
                    leaveTo="transform opacity-0 scale-95"
                  >
                    <Menu.Items
                      className="origin-top-right absolute right-0 mt-2 w-48
                    rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none"
                    >
                      <Menu.Item>
                        {({ active }) => (
                          <Link
                            to={'/'}
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'block px-4 py-2 text-sm text-gray-700',
                            )}
                          >
                            Profile
                          </Link>
                        )}
                      </Menu.Item>
                      <Menu.Item>
                        {({ active }) => (
                          <Link
                            to={'/signout'}
                            className={classNames(
                              active ? 'bg-gray-100' : '',
                              'block px-4 py-2 text-sm text-gray-700',
                            )}
                          >
                            Sign Out
                          </Link>
                        )}
                      </Menu.Item>
                    </Menu.Items>
                  </Transition>
                </Menu>
              </div>
            </div>
          </div>
          <main className="flex-1">
            <div>
              <div className="w-full">{props.children}</div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
});

export default Shell;
